<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ establishment_type.id ? "Editar" : "Novo" }} Tipo de
                Estabelecimento
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Nome:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment_type.establishment_type_name"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="inputUser">
                        <span class="required">*</span> Status:
                      </label>
                      <select
                        v-model="establishment_type.status"
                        class="form-control"
                      >
                        <option :value="1">Ativo</option>
                        <option :value="0">Inativo</option>
                      </select>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>Campos obrigatórios</strong>
                  </span>
                  <div class="block text-right">
                    <router-link
                      to="/establishment_types"
                      class="btn btn-back mr-1"
                    >
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a v-if="$hasAbility('cadastro.gerenciar')" class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      establishment_type: {
        establishment_type_name: "",
        status: "1",
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "establishment_types";

      if (self.establishment_type.id) {
        self.establishment_type._method = "PUT";
        api += "/" + self.establishment_type.id;
      }

      self.$loading(true);

      axios
        .post(api, self.establishment_type)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/establishment_types");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getEstablishmentType: function (id) {
      const self = this;
      const api = self.$store.state.api + "establishment_types/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.establishment_type = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getEstablishmentType(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 255, 128, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>